import AR from '../../public/locales/agroheader/es/ar/translations.json';
import BO from '../../public/locales/agroheader/es/bo/translations.json';
import CL from '../../public/locales/agroheader/es/cl/translations.json';
import CO from '../../public/locales/agroheader/es/co/translations.json';
import PE from '../../public/locales/agroheader/es/pe/translations.json';
import PY from '../../public/locales/agroheader/es/py/translations.json';
import UY from '../../public/locales/agroheader/es/uy/translations.json';
import BR from '../../public/locales/agroheader/pt/br/translations.json';
var translations = {
  'es-AR': AR,
  'es-BO': BO,
  'es-CL': CL,
  'es-CO': CO,
  'es-PE': PE,
  'es-PY': PY,
  'es-UY': UY,
  'pt-BR': BR
};
export function getLanguage(language) {
  return translations[language];
}